import { useParams } from 'react-router-dom'
import { getRequest, postRequest } from '../../../services/base'
import Button from '../../common/Button'
import TracerMappingHeader from './TracerMappingHeader'
import TracerMappingRow from './TracerMappingRow'
import { useContext, useEffect, useState } from 'react'
import { NavContext } from '../../../context/global_context'
import { SET_TR_MAPPING_LIST, TracerMappingContext } from './context/context'
import NoRecordsFound from '../../common/NoRecordsFound'
import InputText from '../../common/InputText'

const TracerMapping = () => {
  let { vehicle } = useParams()
  const [navState, navDispatch] = useContext(NavContext)
  const [state, dispatch] = useContext(TracerMappingContext)
  const [fetchedAfterDate, setFetchedAfterDate] = useState(null)
  const [recordType, setRecordType] = useState('new')
  const [mappingRecords, setMappingRecords] = useState([])

  const tracerAction = async (action, index, map_row) => {
    if (
      window.confirm(`Are you sure want to accept mapping fro tracer`) === true
    ) {
      let res = await postRequest(
        `/api/tracer_mappings/update_mappings/${vehicle}/`,
        state.selected_tracer_mapping
      )
      if (res?.msg) {
        navDispatch({
          type: 'notification',
          data: {
            notification_type: 'error',
            msg: res?.msg,
          },
        })
      }

      if (res?.errors?.length > 0) {
        navDispatch({
          type: 'notification',
          data: {
            notification_type: 'error',
            msg: res?.errors.join(', '),
          },
        })
      }
      if (res?.success?.length > 0) {
        navDispatch({
          type: 'notification',
          data: {
            notification_type: 'success',
            msg: res?.success.join(', '),
          },
        })
      }

      let tempMapping = [...state.tracer_mappings]
      let tempIndex = tempMapping.findIndex(
        (tempEle) =>
          tempEle.dtc === map_row.dtc && tempEle.acronym === map_row.acronym
      )
      tempMapping[tempIndex].logs = res
      dispatch({ type: SET_TR_MAPPING_LIST, data: tempMapping })
      filterRecords(recordType, tempMapping)
    }
  }

  const valideBeforeImport = async () => {
    if (
      window.confirm(
        `Are you sure want to import ${fetchedAfterDate ? 'for selected date' : 'all'} mappings from Tracer`
      ) == true
    ) {
      navDispatch({
        type: 'loader',
        data: {
          caption: 'Fetching DTC Mapping from Tracer...',
          showLoader: true,
        },
        notification: {},
      })
      let res = await postRequest(
        `/api/tracer_mappings/tracer_mappings/${vehicle}/?vehicle=${vehicle}`,
        {
          updated_after: fetchedAfterDate,
        },
        false
      )
      if (res?.status) {
        if (res.data?.length > 0) {
          navDispatch({
            type: 'notification',
            data: {
              notification_type: 'success',
              msg: 'DTC Mapping fetched successfully  from Tracer.',
            },
          })
          dispatch({ type: SET_TR_MAPPING_LIST, data: res.data })
          filterRecords(recordType, res.data)
        } else {
          navDispatch({
            type: 'notification',
            data: {
              notification_type: 'error',
              msg: `Data not found for - ${vehicle}`,
            },
          })
          setMappingRecords([])
        }
      } else {
        navDispatch({
          type: 'notification',
          data: {
            notification_type: 'error',
            msg: res?.msg,
          },
        })
        setMappingRecords([])
      }
    }
  }

  const filterRecords = (record_type, records) => {
    navDispatch({
      type: 'loader',
      data: {
        caption: 'Filtering Mappings...',
        showLoader: true,
      },
      notification: {},
    })
    setRecordType(record_type)
    if (record_type === 'new') {
      let filteredMappings = records.filter(
        (map_obj) =>
          new Date(map_obj.at_updated_at) < new Date(map_obj.updated_at)
      )
      setMappingRecords(filteredMappings)
    } else {
      setMappingRecords(records)
    }
    navDispatch({
      type: 'loader',
      data: {
        caption: '',
        showLoader: false,
      },
      notification: {},
    })
  }

  return (
    <>
      <div className="flex flex-col py-3 space-y-6 w-full">
        <div className="flex justify-between items-center text-white bg-tracer-dark-blue rounded py-2 px-6">
          <div className="flex space-x-4 items-center">
            <InputText
              type="datetime-local"
              isRequired={false}
              placeholder={`Select Date To fetched data`}
              value={fetchedAfterDate}
              onChange={(e) => {
                setFetchedAfterDate(e)
              }}
              name="select-date-time-tracer"
            />
            <Button
              type="submit"
              className={`cursor-pointer btn`}
              onClick={(e) => {
                valideBeforeImport()
              }}
              text={'Import All From Tracer'}
            />
          </div>
          <div className="flex space-x-4 items-center">
            {recordType == 'new' ? (
              <Button
                type="submit"
                className={`cursor-pointer btn`}
                onClick={(e) => {
                  filterRecords('all', state?.tracer_mappings)
                }}
                text={'Show All Records'}
              />
            ) : (
              <Button
                type="submit"
                className={`cursor-pointer btn`}
                onClick={(e) => {
                  filterRecords('new', state?.tracer_mappings)
                }}
                text={'Show New Records'}
              />
            )}
          </div>
        </div>
      </div>
      <div className="container">
        <div className="font-light">
          <TracerMappingHeader />
          {mappingRecords?.length > 0 ? (
            mappingRecords.map((map_row, index) => {
              return (
                <TracerMappingRow
                  key={`tracer-mapping-row-${index}`}
                  {...map_row}
                  showAction={true}
                  TracerAction={(action) => {
                    tracerAction(action, index, map_row)
                  }}
                />
              )
            })
          ) : (
            <NoRecordsFound />
          )}
        </div>
      </div>
    </>
  )
}

export default TracerMapping
